export const Constantes = {
  TIPO_PERSONA: {
    NATURAL_FORMAL: 1,
    JURIDICA: 2,
    NATURAL_INFORMAL: 3,
  },

  VALOR_SI: 'SI',
  VALOR_NO: 'NO',
  ESTADOS_SOLICITUD: {
    EN_BORRADOR_MICROEMPRESARIO: 1,
    ENVIADA: 2,
    VALIDACION_SARLAFT: 3,
    RECHAZADA_SARLAFT: 4,
    DEVUELTA_SOLICITUD_MICROEMPRESARIO: 5,
    PENDIENTE_PROPUESTAS_ALIADOS: 6,
    REVISION_PROPUESTA_MICROEMPRESARIO: 7,
    SIN_PROPUESTAS: 8,
    ACEPTADA_PROPUESTA_MICROEMPRESARIO: 9,
    RECHAZO_PROPUESTA_MICROEMPRESARIO: 10,
    PENDIENTE_FORMALIZACION: 11,
    DESEMBOLSADO_ALIADO: 12,
    FINALIZADA: 18,
    NEGADO_DESEMBOLSO: 19,
    SIN_COBERTURA_GEOGRAFICA: 20,
    CANCELADA_POR_NO_GESTION: 21,
    SIN_COBERTURA_POR_FILTROS: 22
  },

  INTERMEDIARIO: 'intermediario',
  PENDIENTE: 'PENDIENTE',
  DEVUELTA_APROBADOR: 'DEVUELTA APROBADOR',
  PERFIL_ALIADO: 'aliado',
  CREAR_OFERTA: 'Crear oferta',
  VER_DETALLE_SOLICITUD: 'Ver detalle solicitud',
  NEGAR_OFERTA: 'Negar oferta',
  NEGAR_SOLICITUD: 'Negar solicitud',
  CONFIRMAR_DESEMBOLSO: 'Confirmar desembolso',
  DEVOLVER_OFERTA_REVISOR: 'Devolver oferta a revisor',
  NEGAR_DESEMBOLSO: 'Negar desembolso',
  APROBAR_OFERTA: 'Aprobar oferta',
  HOME: 'HOME',
  TRANSACCIONAL: 'TRANSACCIONAL',
}